<div class="eiq-grid-bulk-actions__container" [class.hide]="selectedCount < 1">
  <span class="fs__md fw__600">{{ selectedCount }} {{ itemDescription }} selected</span>
  <div class="eiq-grid-bulk-actions__container__actions">
    <ng-content select="[slot=actions]"></ng-content>
  </div>
</div>
